var VendorPage;
jQuery(function ($) {

    jQuery.expr[':'].contains = function (a, i, m) {
        return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
    }

    VendorPage = {
        stickyEnabled: false,
        initSubmittedReview: function () {
            if (jQuery('#ask_to_share').length) {
                setTimeout(function () {
                    Template.popup("#ask_to_share", [], []);
                    initSharrreButtons("#cboxLoadedContent .facebook-share");
                }, 2000);
            }
        },
        filterReviews: function (href, doNotUpdateHistory) {
            if (typeof href !== 'undefined') {
                if (Modernizr.history && doNotUpdateHistory !== true) {
                    window.history.pushState(null, jQuery('title').html(), href);
                }

                jQuery.post(href, {ajaxReviews: 1}, function (html) {
                    jQuery('.users-reviews-container').html(html);
                    Lazyload.init();
                    starRating.init();

                    Page.scrollTo(jQuery('.users-reviews-container'), 500, -20);

                    Page.finishLoad('reviews-filter');
                }, 'html');
            }
        },
        initMobileScrollbox: function () {
            var $exitPopupOrganic = $('#exit-popup-organic-mobile');
            if ($exitPopupOrganic.length > 0 && jQuery.cookie('_exit_ppc_pp') !== 'true') {
                return;
            }

            jQuery(window).on('scroll', function () {
                if (Base.isPopUpOpened) {
                    return;
                }

                var scrollbox = jQuery('#mobile_header_scrollbox'),
                    showFrom = jQuery('#main_info').offset().top + jQuery('#main_info').outerHeight() - 60,
                    scrollTop = jQuery(document).scrollTop();

                if (scrollbox.hasClass('hidden') && showFrom < scrollTop) {
                    scrollbox.removeClass('hidden');
                }

                if (showFrom > scrollTop && !scrollbox.hasClass('hidden')) {
                    scrollbox.addClass('hidden');
                }
            });
        },
        initDesktopScrollbox: function () {
            jQuery(window).on('scroll', function () {
                var scrollbox = jQuery('#info_scroll_box'),
                    showFrom = jQuery('#main_info').offset().top + jQuery('#main_info').outerHeight() - 60,
                    scrollTop = jQuery(document).scrollTop();

                if (scrollbox.hasClass('hidden') && showFrom < scrollTop) {
                    scrollbox.removeClass('hidden');
                    jQuery('#quick-nav').addClass('top-space');
                }

                if (showFrom > scrollTop && !scrollbox.hasClass('hidden')) {
                    scrollbox.addClass('hidden');
                    jQuery('#quick-nav').removeClass('top-space');
                }
            });
        },

        initPopularReadersSlider: function () {
            var $readersCarouselHolder = jQuery('.popular-readers-items.mobile');

            if ($readersCarouselHolder.find('.popular-reader-item').length < 2) {
                return false;
            }

            var slickInitialized = false;

            jQuery(window).on('resize', function () {
                if (Device.isMobile()) {
                    if (!slickInitialized) {
                        $readersCarouselHolder.find('.readers-carousel').slick({
                            prevArrow: '<a href="#" class="slick-prev" aria-label="Previous slide"></a>',
                            nextArrow: '<a href="#" class="slick-next" aria-label="Next slide"></a>',
                            initialSlide: 1
                        });

                        slickInitialized = true;
                    } else {
                        $readersCarouselHolder.find('.readers-carousel').slick('resize');
                    }
                } else {
                    if (slickInitialized) {
                        slickInitialized = false;
                        $readersCarouselHolder.find('.readers-carousel').slick('unslick');
                    }
                }

            });
        },

        init: function () {
            var self = this;

            self.initSubmittedReview();
            self.initPopularReadersSlider();
            self.initMobileScrollbox();
            self.initDesktopScrollbox();

            //selected review
            jQuery('.selected-review').each(function () {
                var reviewEl = jQuery(this);

                Page.scrollTo(reviewEl, 0);

                reviewEl.addClass('selected-review-loaded');


                setTimeout(function () {
                    reviewEl.removeClass('selected-review-loaded');
                }, 1000);
            });

            //pros cons mobile content trigger
            jQuery(document).on('click', '#pros_cons .card-title', function () {
                jQuery(this).parent('.card-mobile').find('.card-body').toggleClass('less');
            });
        }
    };

    VendorPage.init();
});
